// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","container":"App_container__4L7Vo","backgroundCircle":"App_backgroundCircle__06rs0","innerCircle":"App_innerCircle__8iWqy"};